import getNamedContext from "../getNamedContext";
var HeaderBackContext = getNamedContext('HeaderBackContext', undefined);
export default HeaderBackContext;